import type { Directive } from 'vue'

/**
 * v-scroll-hint — yatay kaydırılabilir şeritlerde (sekme çubukları, geniş tablolar) kenar
 * solgunluğu ipucu. Kaydırma çubuğu gizliyken/dokunmatikte kullanıcı sağda devamı olduğunu
 * göremiyordu. Yalnız sınıf basar; görsel `.scroll-hint-*` (styles/responsive.css) mask ile.
 *
 *   <nav class="tabs" v-scroll-hint>…</nav>
 */
const KEY = '__scrollHint'

function update(el: HTMLElement) {
    const max = el.scrollWidth - el.clientWidth
    const left = max > 1 && el.scrollLeft > 1
    const right = max > 1 && el.scrollLeft < max - 1
    el.classList.toggle('scroll-hint-left', left)
    el.classList.toggle('scroll-hint-right', right)
}

export const scrollHint: Directive<HTMLElement> = {
    mounted(el) {
        const onScroll = () => update(el)
        el.addEventListener('scroll', onScroll, { passive: true })
        const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(onScroll) : null
        ro?.observe(el)
        const mo = typeof MutationObserver !== 'undefined' ? new MutationObserver(onScroll) : null
        mo?.observe(el, { childList: true, subtree: true, characterData: true })
        ;(el as any)[KEY] = { onScroll, ro, mo }
        update(el)
    },
    updated(el) { update(el) },
    unmounted(el) {
        const s = (el as any)[KEY]
        if (!s) return
        el.removeEventListener('scroll', s.onScroll)
        s.ro?.disconnect()
        s.mo?.disconnect()
        delete (el as any)[KEY]
    }
}
